import ConfigService from '../../../shared/configService';
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import psdetaildashboard_en from "../../../translations/en/psdetaildashboard.json";
import Utils from '../../../shared/utils';

interface IProps {
    rbList: any[],
    splitValueList: any[],
    openTabEvent: any

}
i18next.init({
    interpolation: { escapeValue: false },
    lng: 'en',
    resources: {
        en: {

            psdetaildashboard: psdetaildashboard_en
        }
    },
});

const openPolicyTab = async (sectionTab: any, type: any) => {
    const collapsables = document.querySelectorAll('#' + type + '.collapsable');
    let hasHiddenItems = false;
    const secTabItm = collapsables[0].querySelectorAll('.collapsabel__item')[sectionTab];
    if (secTabItm.classList.contains('open')) {
        hasHiddenItems = true;
    }

    const removeItem = collapsables[0].querySelectorAll('.collapsabel__item');
    const rmhightAuto = collapsables[0].querySelectorAll('.collapsabel__item__body.heightAutoAccordion')
    removeItem.forEach(removeItems => {
        const collapsableItemBody = removeItems.querySelector('.collapsabel__item__body');
        if (removeItems.classList.contains('open')) {
            removeItems.classList.remove('open');
            if (collapsableItemBody) {
                collapsableItemBody.classList.remove('heightAutoAccordion');
            }
            else if (rmhightAuto) {
                rmhightAuto[0].classList.remove('heightAutoAccordion');
            }
        }
    });

    const colSecTab = collapsables[0].querySelectorAll('.collapsabel__item')[sectionTab];
    const colItem = collapsables[0].querySelectorAll('.collapsabel__item__body')[sectionTab];
    if (hasHiddenItems == true) {
        colSecTab.classList.remove('open');
        colItem.classList.remove('heightAutoAccordion');
    }
    else {

        colSecTab.classList.add('open');
        colItem.classList.add('heightAutoAccordion');
    }
}

export const PSSectionInterventionTypesList = (props: IProps) => {
    const { t } = useTranslation('psdetaildashboard');
    return (
        <div className="collapsable" id="divAreaLand">
            <div className="interventionTypesList">
                {
                    props.rbList.map((oneRB: any, i: number) => (
                        <>
                            <div>
                                <div className={`collapsabel__item ${i == 0 ? "open" : (i > 4 ? "hidden" : "")}`}>
                                    <button type="button" className="collapsabel__item__header" onClick={() => openPolicyTab(i, 'divAreaLand')}>
                                        <span className="tile-title">
                                            {oneRB.NAME_0}
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.225 13.615">
                                            <path d="m26.11 2.115-11.719 10-12.281-10" fill="none" stroke="#197058" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                                        </svg>
                                    </button>
                                    <div className={`collapsabel__item__body heightAutoAccordion interventionMarginBtm`}>
                                        {/* <div className={`collapsabel__item__body ${i == 0 ? "heightAutoAccordion" : "heightAccordion"}`}>  */}
                                        <div className="alignwide">
                                            <div>
                                                <p className="pQues">{t('areaOfLand.restorationHectares')} </p>
                                                <p><span className="normaltxt">{oneRB.ha_restoration_data == "1" ? 'Yes' : 'No'}</span> </p>
                                                <p className="pQues">{t('areaOfLand.hectareNumber')} </p>
                                                <p><span className="normaltxt">{oneRB.ha_under_resto}</span> </p>
                                                <p className="pQues">{t('areaOfLand.dataClassification')} </p>
                                                <p><span className="normaltxt">{oneRB.ha_tier}</span> </p>
                                                {oneRB['area_restoration_system'] != null && oneRB['area_restoration_system'] != '' &&
                                                    <><p className="pQues">{t('areaOfLand.areaUnderRestoration')} </p><p><span className="normaltxt">{Utils.removeHTMLTag(oneRB.area_restoration_system)}</span> </p></>
                                                }
                                                {oneRB['ha_information'] != null && oneRB['ha_information'] != '' &&
                                                    <>
                                                        <p className="pQues">{t('areaOfLand.relevantInformation')} </p><p><span className="normaltxt">{Utils.removeHTMLTag(oneRB.ha_information)}</span> </p>
                                                    </>
                                                }
                                                {oneRB['ha_links'] != null && oneRB['ha_links'] != '' &&
                                                    <>
                                                        <p className="pQues">{t('areaOfLand.relevantCitations')} </p>
                                                        <p><span className="normaltxt">{Utils.removeHTMLTag(oneRB.ha_links)}</span> </p>
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </>
                    ))
                }

                {props.splitValueList.length > 0 &&
                    <div className='divSplitVal'>
                        <p className="pQues">{t('areaOfLand.restorationInterventions')}</p>
                        <div className="two-column-info-content-container">
                            <div className="two-column-info-content">

                                <div className="psarealandrow">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="text-center"> {t('areaOfLand.ecosystem')} </th>
                                                <th className="text-center"> {t('areaOfLand.interventiontype')} </th>
                                                <th className="text-center"> {t('areaOfLand.areaunderha')} </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props.splitValueList.length > 0 ?

                                                props.splitValueList.map((oneRBSplit: any, i: number) => (
                                                    <>
                                                        <tr>
                                                            <td >
                                                                <span className="normaltxt">{oneRBSplit.ecosystem_id}</span>
                                                            </td>
                                                            <td >
                                                                <span className="normaltxt">{oneRBSplit.intervention_type_id}</span>
                                                            </td>
                                                            <td className='tdsplitup'>
                                                                <span className="normaltxt rightposition">{((oneRBSplit.splitup_value))} </span>
                                                            </td>

                                                        </tr>
                                                    </>
                                                ))
                                                :
                                                <tr>
                                                    <td >
                                                        <span className="normaltxt"></span>
                                                    </td>
                                                    <td >
                                                        <span className="normaltxt"></span>
                                                    </td>
                                                    <td className='tdsplitup'>
                                                        <span className="normaltxt rightposition"></span>
                                                    </td>

                                                </tr>

                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <br />

                            </div >

                        </div>
                    </div>
                }
            </div >
        </div>
    )
}

export default PSSectionInterventionTypesList;